import { ReactNode } from 'react';
import Facebook from 'components/icons/facebook';
import InstagramSolid from 'components/icons/instagramSolid';
import WhatsAppSolid from 'components/icons/whatsAppSolid';
import TiktokIcon from 'components/icons/tiktokSolid';
import TelegramIcon from 'components/icons/telegram';
import ChatbotIcon from 'components/icons/chatbotIcon';
import LinkedInIcon from 'components/icons/linkedin';

export type KnownSalesChannelKey =
    | 'facebook'
    | 'instagram'
    | 'whatsapp'
    | 'tiktok'
    | 'telegram'
    | 'widget_chatbot'
    | 'linkedin';

const VALID_KEYS = new Set<KnownSalesChannelKey>([
    'facebook',
    'instagram',
    'whatsapp',
    'tiktok',
    'telegram',
    'widget_chatbot',
    'linkedin',
]);

const ALIASES: Record<string, KnownSalesChannelKey> = {
    fb: 'facebook',
    ig: 'instagram',
    wa: 'whatsapp',
    chatbot: 'widget_chatbot',
};

export const normalizeSalesChannelKey = (raw: string): KnownSalesChannelKey | undefined => {
    const key = raw.trim().toLowerCase().replace(/[\s-]+/g, '_');
    if (VALID_KEYS.has(key as KnownSalesChannelKey)) {
        return key as KnownSalesChannelKey;
    }
    const alias = ALIASES[key];
    return alias;
};

const renderChannelTypeIcon = (channelKey: string): ReactNode => {
    const key = normalizeSalesChannelKey(channelKey);
    if (!key) return null;

    switch (key) {
        case 'facebook':
            return <Facebook title="Facebook" />;
        case 'instagram':
            return <InstagramSolid title="Instagram" />;
        case 'whatsapp':
            return <WhatsAppSolid title="WhatsApp" />;
        case 'tiktok':
            return <TiktokIcon title="TikTok" />;
        case 'telegram':
            return <TelegramIcon title="Telegram" />;
        case 'widget_chatbot':
            return <ChatbotIcon title="Chatbot" />;
        case 'linkedin':
            return <LinkedInIcon title="LinkedIn" />;
        default:
            return null;
    }
};

export default renderChannelTypeIcon;
